import React from 'react'
import { Link } from 'react-router-dom'

const focusRing =
  'focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ember focus-visible:tw-ring-offset-2'

function RailItem({ entry, active, showLabel, onNavigate }) {
  const Icon = entry.icon
  const className = `tw-flex tw-h-10 tw-items-center tw-rounded-[10px] ${
    showLabel ? 'tw-w-full tw-gap-1 tw-pr-3' : 'tw-w-10 tw-justify-center'
  } ${active ? 'tw-bg-emberSoft tw-text-ember' : 'tw-text-inkSoft hover:tw-bg-sand'} ${focusRing}`
  const content = (
    <>
      <span className='tw-flex tw-h-10 tw-w-10 tw-shrink-0 tw-items-center tw-justify-center'>
        <Icon aria-hidden='true' className='tw-h-5 tw-w-5' />
      </span>
      {showLabel && (
        <span className={`tw-truncate tw-text-[14px] ${active ? 'tw-font-semibold tw-text-ember' : 'tw-font-medium tw-text-ink'}`}>
          {entry.label}
        </span>
      )}
    </>
  )

  return (
    <li className='tw-group tw-relative'>
      {entry.href ? (
        <a href={entry.href} onClick={onNavigate} aria-label={showLabel ? undefined : entry.label} className={className}>
          {content}
        </a>
      ) : (
        <Link to={entry.to} onClick={onNavigate} aria-current={active ? 'page' : undefined} aria-label={showLabel ? undefined : entry.label} className={className}>
          {content}
        </Link>
      )}
      {!showLabel && (
        <span role='tooltip' className='tw-pointer-events-none tw-absolute tw-left-full tw-top-1/2 tw-z-50 tw-ml-3 tw-hidden -tw-translate-y-1/2 tw-whitespace-nowrap tw-rounded-[10px] tw-bg-ink tw-px-2.5 tw-py-1.5 tw-text-[12px] tw-font-medium tw-text-white tw-shadow-pop group-hover:tw-block group-has-[:focus-visible]:tw-block'>
          {entry.label}
        </span>
      )}
    </li>
  )
}

function IconRail({ entries, activeKey, expanded = false, variant = 'fixed', onNavigate }) {
  const showLabel = variant === 'panel' || expanded
  const mainEntries = entries.filter((entry) => entry.pinned !== 'bottom')
  const bottomEntries = entries.filter((entry) => entry.pinned === 'bottom')
  const containerClass = variant === 'fixed'
    ? `tw-fixed tw-inset-y-0 tw-left-0 tw-z-40 tw-hidden tw-border-r tw-border-line tw-bg-white tw-transition-[width] tw-duration-200 md:tw-flex ${expanded ? 'tw-w-[220px]' : 'tw-w-[72px]'}`
    : 'tw-flex tw-h-full tw-w-full tw-bg-white'
  const listClass = `tw-flex tw-flex-col tw-gap-1 ${showLabel ? 'tw-items-stretch' : 'tw-items-center'}`
  const renderItems = (items) => items.map((entry) => (
    <RailItem key={entry.key} entry={entry} active={entry.key === activeKey} showLabel={showLabel} onNavigate={onNavigate} />
  ))

  return (
    <nav aria-label='Main' className={`${containerClass} tw-min-w-0 tw-flex-col tw-px-4 tw-py-4`}>
      <Link to='/' onClick={onNavigate} aria-label='LoyalIdeas overview' className={`tw-mb-6 tw-flex tw-h-10 tw-items-center tw-rounded-[10px] ${showLabel ? 'tw-gap-2 tw-px-2' : 'tw-justify-center'} ${focusRing}`}>
        <img src='/img/logo.svg' alt='' className='tw-h-8 tw-w-auto' />
        {showLabel && <span className='tw-font-heading tw-text-[16px] tw-font-extrabold tw-text-ink'>LoyalIdeas</span>}
      </Link>
      <ul className={listClass}>{renderItems(mainEntries)}</ul>
      <ul className={`${listClass} tw-mt-auto tw-pt-4`}>{renderItems(bottomEntries)}</ul>
    </nav>
  )
}

export default IconRail
